import { memo } from "react";
import { Colors } from "../../utils/colors";
import { MessageBubble } from "../AnimationContainers/MessageBubble";
import { Icon } from "@iconify/react";
import TextingMadeHuman from "../../assets/LandingPage/TextingMadeHuman.png";

type TextingThatFeelsHumanFoldProps = {
  isDesktopSize: boolean;
  getStartedOnPress: (btnSource: string) => void;
};

// Used as one of the folds on the landing pages
const TextingThatFeelsHumanFold = (props: TextingThatFeelsHumanFoldProps) => {
  const { isDesktopSize, getStartedOnPress } = props;

  const styles = {
    headerText: {
      fontSize: isDesktopSize ? 64 : 48,
      fontWeight: 500,
      letterSpacing: "-0.5px",
      color: Colors.WHITE,
    },

    largeImage: {
      width: "100%",
      height: "auto",
    },
  };

  return (
    <div
      className="AlignedColumn"
      style={{
        paddingBlock: isDesktopSize ? 80 : 60,
        backgroundImage:
          "radial-gradient(ellipse at top, #112C65 0%, #000000 53%)",
      }}
    >
      <h2
        style={{
          ...styles.headerText,
          paddingBottom: 30,
          color: Colors.WHITE,
          textAlign: "center",
        }}
      >
        {isDesktopSize ? (
          <>Texting that feels Human</>
        ) : (
          <>
            Texting
            <br />
            that feels
            <br />
            Human
          </>
        )}
      </h2>
      <MessageBubble
        text={
          <div className="AlignedRowSelect" style={{ gap: 4 }}>
            <span style={{ color: Colors.WHITE }}>Start Texting for Free</span>
            <Icon
              icon="ion:chevron-forward"
              height={16}
              style={{ color: Colors.WHITE, marginBottom: -1 }}
            />
          </div>
        }
        tailPosition="bottomLeft"
        onPress={() => getStartedOnPress("Start Texting Last Fold")}
        containerStyles={{
          borderRadius: 22,
          fontSize: isDesktopSize ? 16 : 12,
          fontWeight: 500,
          padding: "12px 16px",
        }}
      />
      <img
        src={TextingMadeHuman}
        alt="Creator Subscriber Collage"
        className="slide-up"
        style={{
          ...styles.largeImage,
          paddingTop: 60,
          objectFit: "contain",
          maxWidth: isDesktopSize ? 480 : 336,
        }}
      />
    </div>
  );
};

export default memo(TextingThatFeelsHumanFold);
